import { useCallback, useEffect } from "react";
import { Navigate, useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { localStorageHelper } from "../../helpers";
import { links } from "../../constants/links";

export const RestrictedRoute = ({
  children,
  restricted = false,
  isPrivate,

  title,
}: IRestrictedRoute): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const forceLogin = location.state?.forceLogin || searchParams.get("force_login") === "true";

  const redirect = useCallback(() => {
    if (restricted && window.localStorage.getItem("session-id") && !forceLogin) {
      navigate(links.EARN_PAGE,  { replace: true });
    }
    // eslint-disable-next-line
  }, [isPrivate, navigate, restricted]);

  useEffect(() => {
    redirect();
  }, [redirect]);

  useEffect(() => {
    if (typeof title === "string") {
      document.title = title;
    }
    // eslint-disable-next-line
  }, []);

  // return <Route path={path} element={<>{children}</>} />;
  if (!location.pathname.includes("use-reward")) {
    return (localStorageHelper.isLogin() && isPrivate) || !isPrivate ? children : <Navigate to="/login" />;
  } else {
    return children;
  }
};

interface IRestrictedRoute {
  children?: any;
  restricted?: boolean;
  isPrivate?: boolean;
  layout?: any;
  path?: any;
  title?: string;
}
